import { render, staticRenderFns } from "./tianHeChildrenEnrolmentReport.vue?vue&type=template&id=15230ca6&scoped=true"
import script from "./tianHeChildrenEnrolmentReport.vue?vue&type=script&lang=js"
export * from "./tianHeChildrenEnrolmentReport.vue?vue&type=script&lang=js"
import style0 from "./tianHeChildrenEnrolmentReport.vue?vue&type=style&index=0&id=15230ca6&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15230ca6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15230ca6')) {
      api.createRecord('15230ca6', component.options)
    } else {
      api.reload('15230ca6', component.options)
    }
    module.hot.accept("./tianHeChildrenEnrolmentReport.vue?vue&type=template&id=15230ca6&scoped=true", function () {
      api.rerender('15230ca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printReport/tianHeChildrenEnrolmentReport/tianHeChildrenEnrolmentReport.vue"
export default component.exports